import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import api from "@/api";
import { data } from "@/mock/menu";

type initialStateType = {
  menus: any[];
  userInfo: any;
  exStatus: any;
};
const initialState: initialStateType = {
  menus: data,
  userInfo: {},
  exStatus: {},
};

export const userSlice = createSlice({
  // 命名空间，在调用action的时候会默认的设置为action的前缀collapsedSlice/changeCollapsed
  name: "userSlice",
  // 初始值
  initialState: initialState,
  // 这里的属性会自动的导出为collapsedSlice.actions，在组件中可以直接通过dispatch进行触发
  reducers: {
    changeMenus: (state, action: PayloadAction<any[]>) => {
      state.menus = action.payload;
    },
    changeUserInfo: (state, action: PayloadAction<any>) => {
      state.userInfo = action.payload;
    },
    changeExStatus: (state, action: PayloadAction<any>) => {
      state.exStatus = action.payload;
    },
  },
});

// 异步登录
export const LoginUserAction = (
  data: any,
  navigate: any,
  fn: any,
  fn1: any
): any => {
  return (dispatch: any) => {
    // console.log('LoginUserAction called');
    // // 设置token以通过路由守卫
    // localStorage.setItem("token", "fake-token");
    // // 直接设置用户信息（模拟登录成功状态）
    // const mockUserInfo = {
    //   username: "测试用户",
    //   id: 1,
    //   sipnumber: "8888723002", // ✅ 分机号，用于后续 MakeCall、查询等操作
    //   userid: "123456",   // ✅ 模拟用户 ID，用于呼叫等附加参数
    // };
    // dispatch(changeUserInfo(mockUserInfo));
    // console.log('User info dispatched');
    // // 直接跳转首页
    // console.log('Navigating to home');
    // // 延迟导航确保状态更新完成
    // setTimeout(() => {
    //   navigate("/");
    // }, 100);
    //   // 开发模式下直接跳转，生产环境调用真实接口
    //   if (process.env.NODE_ENV === 'development') {
    //     dispatch(changeUserInfo({username: "testuser", id: 1}));
    //     navigate("/");
    //     return;
    //   }
    fn1(true);
    api.user.LoginApi(data).then((res: any) => {
      console.log(res);
      fn1(false);
      if (res?.data?.code === 0) {
        localStorage.setItem("token", res?.data?.data?.token);
        localStorage.setItem("url", res?.data?.data?.api_url);
        localStorage.setItem("call_node", res?.data?.data?.call_node);
        dispatch(changeUserInfo(res?.data?.data));
        navigate("/");
      } else {
        fn();
      }
    });
  };
};

// 导出actions
export const { changeMenus, changeUserInfo, changeExStatus } =
  userSlice.actions;

// 导出reducer，在创建store时使用到
export default userSlice.reducer;
